import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/index&str=:id',
    name: 'home',
    component: HomeView
  },
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  {
    path: '/HomeView',
    name: 'HomeView',
    component: HomeView
  },
]

const router = new VueRouter({
  routes
})

export default router
